import React, { useEffect, useState, useCallback } from 'react'
import { useNavigate } from 'react-router-dom';
import { getSession, clearSession } from '../customHooks/useSession';
import { useIdleTimer } from 'react-idle-timer';
import { Modal, Button, Progress, Space, Typography } from 'antd';
import { ExclamationCircleOutlined, LogoutOutlined, CheckCircleOutlined } from '@ant-design/icons';

const { Text, Title } = Typography;

function Protected(props) {
  const { Component } = props;
  const navigate = useNavigate()
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [remainingTime, setRemainingTime] = useState(60);
  const totalWarningTime = 60;

  const handleOnIdle = useCallback(() => {
    setIsModalOpen(false);
    clearSession()
    localStorage.clear()
    sessionStorage.clear()
  }, []);

  const handleOnPrompt = useCallback(() => {
    setIsModalOpen(true);
    setRemainingTime(totalWarningTime);
  }, []);

  const handleOnActive = useCallback(() => {
    // This will be called when activity is detected OR when activate() is called in another tab
    setIsModalOpen(false);
  }, []);

  const { activate, getRemainingTime } = useIdleTimer({
    timeout: 1800000, // 30 minutes
    promptBeforeIdle: totalWarningTime * 1000,
    onIdle: handleOnIdle,
    onPrompt: handleOnPrompt,
    onActive: handleOnActive,
    crossTab: true,
    syncTimers: 200,
  })

  const handleStayLoggedIn = () => {
    activate();
    setIsModalOpen(false);
  }

  useEffect(() => {
    let interval;
    if (isModalOpen) {
      interval = setInterval(() => {
        const remaining = Math.ceil(getRemainingTime() / 1000);
        setRemainingTime(remaining > 0 ? remaining : 0);
      }, 500);
    }
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [isModalOpen, getRemainingTime]);

  useEffect(() => {
    const token = getSession("token");
    if (!token) {
      navigate("/")
    }
  }, [])

  return getSession("token") && (
    <div>
      <Component />
      <Modal
        open={isModalOpen}
        footer={null}
        closable={false}
        maskClosable={false}
        centered
        width={400}
        styles={{
          body: {
            padding: '30px 24px',
            textAlign: 'center'
          }
        }}
      >
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <div style={{
            background: '#fffbe6',
            width: '64px',
            height: '64px',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto',
            border: '1px solid #ffe58f'
          }}>
            <ExclamationCircleOutlined style={{ fontSize: '32px', color: '#faad14' }} />
          </div>

          <div>
            <Title level={4} style={{ marginBottom: 8, marginTop: 0 }}>Session Security Warning</Title>
            <Text type="secondary">
              Your session is about to expire due to inactivity. For your security, you will be logged out automatically.
            </Text>
          </div>

          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Progress
              type="circle"
              percent={(remainingTime / totalWarningTime) * 100}
              format={() => `${remainingTime}s`}
              strokeColor={{
                '0%': '#ff4d4f',
                '100%': '#faad14',
              }}
              size={80}
            />
          </div>

          <Space size="middle" style={{ width: '100%', justifyContent: 'center', marginTop: 8 }}>
            <Button
              size="large"
              icon={<LogoutOutlined />}
              onClick={handleOnIdle}
              style={{ borderRadius: '8px' }}
            >
              Logout Now
            </Button>
            <Button
              type="primary"
              size="large"
              icon={<CheckCircleOutlined />}
              onClick={handleStayLoggedIn}
              style={{
                borderRadius: '8px',
                background: '#1890ff',
                boxShadow: '0 2px 0 rgba(24, 144, 255, 0.1)'
              }}
            >
              Stay Logged In
            </Button>
          </Space>
        </Space>
      </Modal>
    </div>
  )
}

export default Protected